import { acceptCreditOperation } from './accept-credit-operation';
import { acceptInstallmentAnticipation } from './accept-installment-anticipation';
import { getCreditFlags } from './get-credit-flags';
import { getCreditOperations } from './get-credit-operations';
import { getInstallmentAnticipations } from './get-installment-anticipations';
import { getRefunds } from './get-refunds';
import { rejectCreditOperation } from './reject-credit-operation';
import { rejectInstallmentAnticipation } from './reject-installment-anticipation';

const AccountingServices = {
  getCreditOperations,
  getInstallmentAnticipations,
  getCreditFlags,
  getRefunds,
  rejectCreditOperation,
  acceptCreditOperation,
  acceptInstallmentAnticipation,
  rejectInstallmentAnticipation,
};

export { AccountingServices };
